import React, { useCallback } from 'react';

import useStream from 'components/streams/hooks/useStream';
import Routes from 'routing/Routes';
import { Link } from 'components/common/router';
import useSendTelemetry from 'logic/telemetry/useSendTelemetry';
import useLocation from 'routing/useLocation';
import { TELEMETRY_EVENT_TYPE } from 'telemetry/Constants';
import { getPathnameWithoutId } from 'util/URLUtils';

type Props = {
  stream_id: string;
};

const DataLakeConnectorStreamCell = ({ stream_id }: Props) => {
  const { data: stream } = useStream(stream_id, { enabled: !!stream_id, refetchInterval: 3000 });
  const sendTelemetry = useSendTelemetry();
  const { pathname } = useLocation();

  const handleClick = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE.CONNECTORS.STREAM_NAME_LINK_CLICKED, {
      app_pathname: getPathnameWithoutId(pathname),
    });
  }, [pathname, sendTelemetry]);

  return (
    <td>
      <Link to={Routes.stream_search(stream_id)} onClick={handleClick}>
        {stream?.title}
      </Link>
    </td>
  );
};

export default DataLakeConnectorStreamCell;
